/**
 * @name: liveManagement.js
 * @description: 直播管理路由
 * @author: 杨波
 * @create: 2020/12/01 14:16:51
 * @update: 2020/12/01 14:16:51
 */

export default [
  {
    path: '/live/room/list',
    name: 'liveRoomManagement',
    component: () => import('@/views/live/room/List'),
    meta: {
      title: '直播间列表'
    }
  },
  {
    path: '/live/room/add',
    name: 'addLiveRoom',
    component: () => import('@/views/live/room/Add'),
    meta: {
      title: '创建直播间',
      parentRoutePath: 'liveRoomManagement'
    }
  },
  {
    path: '/live/room/detail',
    name: 'liveRoomDetail',
    component: () => import('@/views/live/room/Detail'),
    meta: {
      title: '直播间详情',
      parentRoutePath: 'liveRoomManagement'
    }
  },
  {
    path: '/live/room/goodslist',
    name: 'addLiveRoomGoodsList',
    component: () => import('@/views/live/room/GoodsList'),
    meta: {
      title: '直播间商品列表',
      parentRoutePath: 'liveRoomManagement'
    }
  },
  {
    path: '/live/room/addgoods',
    name: 'addLiveRoomGoods',
    component: () => import('@/views/live/room/AddGoods'),
    meta: {
      title: '直播间添加商品',
      parentRoutePath: 'addLiveRoomGoodsList'
    }
  },
  {
    path: '/live/streamer/list',
    name: 'streamerManagement',
    component: () => import('@/views/live/streamer/List'),
    meta: {
      title: '主播列表'
    }
  },
  {
    path: '/live/member/list',
    name: 'liveMemberManagement',
    component: () => import('@/views/live/member/List'),
    meta: {
      title: '观看直播会员'
    }
  },
];
